import { Checkbox, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { ResourcePermission } from '@store/types';
import styled from 'styled-components';

const Container = styled.div`
  & .MuiListItem-root {
    height: 55px;
    background-color: ${({ theme }) => theme.background.lighter};
  }

  & .MuiListItemButton-root {
    background-color: ${({ theme }) => theme.background.lighter} !important;
    padding-top: 4px;
    padding-bottom: 4px;
  }

  & .MuiListItemIcon-root {
    svg {
      font-size: 2.2ch;
    }

    margin-right: 4px;
  }

  & .MuiListItemText-primary {
    font-size: 13px !important;
    margin: 0 !important;
  }

  & .MuiListItemText-secondary {
    font-size: 13px !important;
    margin: 0 !important;
  }
`;

interface Props {
  editing: boolean;
  resource: ResourcePermission;
  selected: boolean;
  onSelect: (resource: ResourcePermission) => void;
}

export const Group: React.FC<Props> = ({ resource, editing, selected, onSelect }) => {
  return (
    <Container>
      <ListItemButton sx={{ pl: 3 }} onClick={() => onSelect(resource)}>
        <ListItemIcon>
          <Checkbox edge='start' disabled={!editing} disableRipple checked={selected} tabIndex={-1} />
        </ListItemIcon>
        <ListItemText primary={resource.action} secondary={resource.description} />
      </ListItemButton>
    </Container>
  );
};
